import React from 'react';
import PropTypes from 'prop-types';
import CSSModules from 'react-css-modules';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { injectIntl } from 'react-intl';

import {
    showHeaderFlashMessage
} from '@client/redux/modules/flashMessage/actions';
import {
    FLASH_MESSAGE_TYPE_SUCCESS
} from '@client/config/constants';
import {
    TimeLeftBold
} from '@client/components/shared/Shared';

import Reminder from '../Reminder';
import OpenReminder from '../OpenReminder';

import internalStyles from './upcomingCampaign.scss';

/* eslint-disable react/no-did-mount-set-state */

export class UpcomingCampaign extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false
        };
        this.updateOpenState = this.updateOpenState.bind(this);
        this.pageRefresh = this.pageRefresh.bind(this);
    }

    render() {
        const {
            campaign,
            imageUrl,
            minHeight,
        } = this.props;

        const {
            isOpen
        } = this.state;

        const campaignId = `campaign-${campaign.campaignIdentifier}`;
        const coverWithoutLogo = !campaign.hasLogo;

        return (
            <div
                id={campaignId}
                styleName="wrapper"
                style={{ minHeight }}
            >
                <div styleName="inner-wrapper">
                    {coverWithoutLogo && (
                        <div styleName="title-label">
                            {campaign.name}
                        </div>
                    )}
                    <img src={imageUrl} alt="upcoming-campaign" styleName="img" />
                    <div styleName="info">
                        <div styleName="info-label-wrapper">
                            <div styleName="info-label-time">
                                <span styleName="info-time">
                                    <TimeLeftBold dateTill={campaign.dateStart} isUpcoming={true} expiredCallback={this.updateOpenState} />
                                </span>
                            </div>
                            { isOpen ? <OpenReminder campaign={campaign} /> : <Reminder campaign={campaign} />}
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    updateOpenState() {
        if (!this.state.isOpen) {
            this.setState({ isOpen: true });
            this.props.showHeaderFlashMessage(
                FLASH_MESSAGE_TYPE_SUCCESS,
                this.props.intl.formatMessage({ id: 'campaigns.upcomingCampaignActive' }),
                'LoadIcon',
                this.pageRefresh
            );
        }
    }

    // When an upcoming campaign goes live, clicking the flash message should trigger a page reload
    pageRefresh() {
        window.location.reload();
    }
}

UpcomingCampaign.propTypes = {
    campaign: PropTypes.object.isRequired,
    campaignStyles: PropTypes.object,
    columnCount: PropTypes.number,
    showHeaderFlashMessage: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
    imageUrl: PropTypes.string.isRequired,
    minHeight: PropTypes.number,
};

const mapDispatchToProps = {
    showHeaderFlashMessage
};

export default compose(
    connect(null, mapDispatchToProps),
    injectIntl,
    CSSModules(internalStyles, { allowMultiple: true })
)(UpcomingCampaign);
